import React, { useState } from "react";
import { Link } from "react-router-dom";
import styles from "./mobile_header.module.css";
import SwitcherMenu from "../switcher_menu/switcher_menu";
import SwitcherTelList from "../switcher_tel_list/switcher_tel_list";
import AsideMenu from "../aside_menu/aside_menu";
import AsideTelList from "../aside_tel_list/aside_tel_list";
import MobSearchForm from "../mob_search_form/mob_search_form";
import { SHOP_NAME } from "../../../utils/constants";
import { useSelector } from "react-redux";
import { getUser, getSettings, getPhones } from "../../../services/selectors";

function MobileHeader() {

  const user = useSelector(getUser);
  const phones = useSelector(getPhones);
  const settings = useSelector(getSettings);

  const [checkMenu, setCheckMenu] = useState(false);
  const [checkTelList, setCheckTelList] = useState(false);
  const [searchActive, setSearchActive] = useState(false);

  const handleChecked = () => {
    setCheckMenu(!checkMenu);
    if (checkTelList) {
      handleCheckTelList();
    }
  }

  const handleCheckTelList = () => {
    setCheckTelList(!checkTelList);
    if (checkMenu) {
      handleChecked();
    }
  }

  const handleSearchActive = () => {
    setCheckMenu(false);
    setCheckTelList(false);
    setSearchActive(!searchActive);
  }

  const handleCloseAlMenu = () => {
    setCheckMenu(false);
    setCheckTelList(false);
  }

  return (
    <header className={`${styles.header}`}>
      { searchActive ?
        <MobSearchForm
          handleClose={handleSearchActive}
        />
        :
        <>
          <SwitcherMenu
            checkMenu={checkMenu}
            handleChecked={handleChecked}
          />
          <div className={styles.buttonOpenSearch}
            onClick={handleSearchActive}
          />
          <Link className={`${styles.shopName}`}
            onClick={handleCloseAlMenu}
            to="/"
          >
            { settings.shop_name || SHOP_NAME }
          </Link>
          <SwitcherTelList
            checkTelList={checkTelList}
            handleCheckTelList={handleCheckTelList}
          />
        </>
      }
      <AsideMenu
        checkMenu={checkMenu}
      />
      <AsideTelList
        checkTelList={checkTelList}
        handleCheckTelList={handleCheckTelList}
        phones={phones}
      />

    </header>
  );
}

export default MobileHeader;
